import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Ortak } from './../../../providers/ortak';
import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { BllOrtak } from '../../../providers/bll/bll-ortak';

/**
 * Generated class for the KullanicieklePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-kullaniciekle',
  templateUrl: 'kullaniciekle.html',
})
export class KullanicieklePage {
  kullanici:any={ID:-1};
  user:any={};


  constructor(public navCtrl: NavController,
    public bllOrtak:BllOrtak,
    public ortak:Ortak,
    public viewCtrl:ViewController,

     public navParams: NavParams) {
    if (navParams.get("UserVw") != null) {
      this.user = navParams.get("UserVw");
      var data = new FormData();
      data.append("User_id", this.user.ID);
      this.bllOrtak.islem(data, "UserGetirByID", "", false).then(a => {
        var Sonuc = <any>a;
        this.kullanici = Sonuc.SonucObject;
        console.log("glen kullanici",Sonuc)
     
      }
      )
    }
}

ionViewDidLoad() {
 
}
boslukKontrol() {
  var mesaj = "";
  
  if (this.kullanici.Name == null || this.kullanici.Name == "") {
    mesaj = mesaj + "Lütfen Kullanıcı adını giriniz. <br/>";
  }

  if (mesaj == "") {
    return true;
  }
  else {
    this.ortak.showBasicAlert("Uyarı", mesaj);
    return false;
  }
}
kaydet() {

  var formData = new FormData();
 
  if (this.boslukKontrol()) {
    formData.append("User_json", JSON.stringify(this.kullanici));
   console.log("ass",this.user)
    this.bllOrtak.islem(formData, "KullaniciEkleGuncelle", "", false).then(a => {
      var sonuc = <any>a;
      if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
     

    })
  }
  this.cikis();
  }
  cikis()
  {
    this.viewCtrl.dismiss();
  }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/kullaniciekle/kullaniciekle.ts